import { render, staticRenderFns } from "./TournamentOverviewWrapper.vue?vue&type=template&id=0617e50a&scoped=true"
import script from "./TournamentOverviewWrapper.vue?vue&type=script&lang=js"
export * from "./TournamentOverviewWrapper.vue?vue&type=script&lang=js"
import style0 from "./TournamentOverviewWrapper.vue?vue&type=style&index=0&id=0617e50a&prod&lang=scss"
import style1 from "./TournamentOverviewWrapper.vue?vue&type=style&index=1&id=0617e50a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617e50a",
  null
  
)

export default component.exports